import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, PrimeNGConfig } from 'primeng/api';
import { AppComponent } from 'src/app/app.component';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiCore } from 'src/app/config/api';
import { JwtService } from 'src/app/core/auth/jwt.service';
import { MainLayoutComponent } from '../../main-layout.component';
import { ShareOrderGamesService } from 'src/app/shared/services/shareOrderGames.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  @Input() social_networks: any = [];
  @Output() toggleMenu = new EventEmitter<boolean>();
  
  model: MenuItem[] = [];
  operatorLogo: string | null = 'assets/images/no-photo-available.png';
  showLoadSpin: boolean = false;

  showMenu: boolean = false;
  operatorId: string = '';
  operatorType: string = '';

  loadingMenu: boolean = true;
  private clickedInside: boolean = false;

  sidebarActive = true;
  menuClick: boolean = false;
  menuHoverActive = false;
  topbarMenuActive: boolean = false;
  topbarItemClick: boolean = false;
  activeTopbarItem: any;
  configActive: boolean = false;
  configClick: boolean = false;
  rightMenuActive: boolean = false;
  rightMenuClick: boolean = false;
  searchActive: boolean = false;
  searchClick: boolean = false;
  activeInlineProfile: boolean = false;
  pinActive: boolean = true;
  screenWidth: number = window.innerWidth;
  mobileAgent!: boolean;
  mobileDevice!: boolean;
  overlayMenuActive: boolean = false;
  staticMenuDesktopInactive = false;
  staticMenuMobileActive: boolean = false;
  sidebarStatic = true;

  constructor(
    public app: AppComponent,
    public appMain: MainLayoutComponent,
    private auth: AuthService,
    private apiService: ApiService,
    private router: Router,
    private session: SessionService,
    private jwt: JwtService,
    private primengConfig: PrimeNGConfig,
    private readonly shareOrderGamesService: ShareOrderGamesService
  ) {
    this.shareOrderGamesService.getCategories().subscribe(listCategories => {
      if (listCategories && listCategories.statusCode == 200 && listCategories.data) {
        const menuItems: any = [];

        listCategories.data.forEach((cat: any) => {
          menuItems.push({
            label: cat,
            icon: 'fas fa-lock',
            routerLink: '/app/home/all-games/' + cat,
          });
        });

        this.model = menuItems;
      }
    });
  }

  @HostListener('click')
  clickInside() {
    this.clickedInside = true;
  }

  @HostListener('document:click')
  clickOutside() {
    if (!this.clickedInside) {
      this.showMenu = false;
    }
    this.clickedInside = false;
  }

  ngOnInit() {
    this.loadingMenu = false;
  }

  setMenuData(data: any) {
    return data;
  }

  // param: array of routerLink of all items
  validateMenuExpand = (routes: Array<string>): boolean => {
    const res = routes.map((i) => this.router.url.includes(i));
    const active = res.find((i) => i === true);
    return active === true ? true : false;
  };

  onSidebarClick($event: any) {
    this.menuClick = true;
  }

  onToggleMenu(event: { preventDefault: () => void }) {
    const menuContainer = document.querySelector('.layout-menu-container');

    const isScrolledToBottom = menuContainer? menuContainer.scrollHeight - menuContainer.scrollTop === menuContainer.clientHeight: false;

    this.menuClick = true;

    if (this.overlayMenuActive) {
      this.overlayMenuActive = false;
    }

    if (this.sidebarActive) {
      this.sidebarStatic = !this.sidebarStatic;
    }

    this.sidebarActive = !this.sidebarActive;
    this.pinActive = !this.pinActive;

    if (!this.sidebarActive && isScrolledToBottom) {
      setTimeout(() => {
        const menuContainer = document.querySelector('.layout-menu-container');
        if (menuContainer) {
          menuContainer.scrollTop = menuContainer.scrollHeight;
        }
      }, 200);
    }

    this.toggleMenu.emit(!this.sidebarActive);

    event.preventDefault();
  }

  onSidebarMouseOver(event: any) {
    if (this.app.menuMode === 'sidebar' && !this.sidebarStatic) {
      this.sidebarActive = this.isDesktop();
      setTimeout(() => {
        this.pinActive = this.isDesktop();
      }, 200);
    }
  }

  onSidebarMouseLeave($event: any) {
    if (this.app.menuMode === 'sidebar' && !this.sidebarStatic) {
      setTimeout(() => {
        this.sidebarActive = false;
        this.pinActive = false;
      }, 250);
    }
  }

  onMenuButtonClick(event: { preventDefault: () => void }) {
    this.menuClick = true;

    if (this.isOverlay()) {
      this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.staticMenuMobileActive = !this.staticMenuMobileActive;
    }

    event.preventDefault();
  }

  onTopbarItemClick(event: { preventDefault: () => void }, item: any) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onTopbarSubItemClick(event: { preventDefault: () => void }) {
    event.preventDefault();
  }

  onRippleChange(event: { checked: boolean }) {
    this.app.ripple = event.checked;
    this.primengConfig.ripple = event.checked;
  }

  onConfigClick(event: any) {
    this.configClick = true;
  }

  onRightMenuButtonClick() {
    this.rightMenuClick = true;
    this.rightMenuActive = true;
  }

  onRightMenuClick($event: any) {
    this.rightMenuClick = true;
  }

  isStatic() {
    return this.app.menuMode === 'static';
  }

  isOverlay() {
    return this.app.menuMode === 'overlay';
  }

  isSlim() {
    return this.app.menuMode === 'slim';
  }

  isHorizontal() {
    return this.app.menuMode === 'horizontal';
  }

  isSidebar() {
    return this.app.menuMode === 'sidebar';
  }

  isDesktop() {
    return this.screenWidth > 991;
  }

  isMobile() {
    return this.screenWidth <= 991;
  }

  /**
   * Ya no se usa este metodo, se cambio por un servicio que obtiene las categorias de juegos
   * ya ordenadas y que se llama solo una vez al inicio de la aplicacion y desde un mismo lugar.
   */
  getGameCategories = () => {
    this.apiService.list(ApiCore.LOBBY_PUBLIC_GAME_CAT).subscribe({
      next: (res) => {
        const menuItems: any = [];

        res.data.forEach((cat: any) => {
          menuItems.push({
            label: cat.name,
            icon: 'fas fa-lock',
            routerLink: '/app/home/all-games/' + cat.name,
          });
        });

        this.model = menuItems;
      },
      error: (err) => console.error(err),
    });
  };
}
